/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { Api } from "../../services/interceptor";

export type RosterPlayer = { id: string; name: string; image?: string; bat: string; bowl: string };

const nice = (s?: string | null) =>
  (s ?? "").toString().trim().toLowerCase().split("_").filter(Boolean).map((w, i) => (i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : w)).join(" ");

const batStyle = (s?: string | null) => (/left/i.test(s ?? "") ? "Left-hand bat" : /right/i.test(s ?? "") ? "Right-hand bat" : nice(s));

/** A team's squad in the tournament (players still waiting for approval are left out, as the squad count does). */
export const useRoster = (ts?: string) =>
  useQuery({
    queryKey: ["tgRoster", ts],
    enabled: !!ts,
    staleTime: 30_000,
    queryFn: async (): Promise<RosterPlayer[]> => {
      const raw = (await Api.get(`playersByTeamSnapshotId/${ts}`)).data;
      const list: any[] = Array.isArray(raw) ? raw : (raw?.data ?? []);
      const seen = new Set<string>();
      return list
        .filter((p) => String(p.playerRole ?? "").toUpperCase() !== "PENDING_APPROVAL")
        .filter((p) => (p.playerId && !seen.has(p.playerId) ? (seen.add(p.playerId), true) : false))
        .map((p) => ({
          id: String(p.playerId),
          name: [p.playerFirstName, p.playerLastName].filter(Boolean).join(" ").trim() || "Player",
          image: p.imageUri || undefined,
          bat: batStyle(p.battingStyle),
          bowl: nice(p.bowlingStyle),
        }));
    },
  });
